"use client"

import { useRouter } from "next/navigation"
import { useEffect } from "react"
import { useReferral } from "@/hooks"
import { AppLoader } from "./AppLoader"

interface IProps {
  to?: string
  from?: string
  ref?: string
}

export function Redirect({ to = "/", ref }: IProps) {
  const [_, setReferral, removeReferral] = useReferral()
  const router = useRouter()

  useEffect(() => {
    if (ref) setReferral(ref)
    else removeReferral()

    router.replace(to)
  }, [to, ref])

  return <AppLoader />
}
